











import ServiceRegisterHeader from '@/components/service/register/ServiceRegisterHeader.vue';
import ServiceRegisterError from '@/components/service/register/ServiceRegisterError.vue';
import Footers from '@/components/Footers.vue';
import {Vue, Component} from 'vue-property-decorator';
import {
  GetServicesTempRequest, GetServicesTemp,
  GetAdminsTempServiceRequest, GetAdminsTempService
} from 'supporter';
import ServiceRegisterAgreeTerms from '@/components/service/register/ServiceRegisterAgreeTerms.vue';
import {toI18n} from '@/utils/commonUtils';

enum REGISTER_STATUS {
  NONE = 'NONE',
  REGISTER = 'REGISTER',
  ACTIVE = 'ACTIVE',
  INVESTIGATION = 'INVESTIGATION',
  ERROR = 'ERROR'
}

@Component({
  components: {ServiceRegisterError, ServiceRegisterHeader, Footers, ServiceRegisterAgreeTerms}
})
export default class DefaultView extends Vue {
  private status: REGISTER_STATUS = REGISTER_STATUS.NONE;

  private serviceData: GetServicesTemp | null = null;
  private masterData: GetAdminsTempService | null = null;

  private isErrorStatus(): boolean {
    return this.status === REGISTER_STATUS.ERROR;
  }

  private getServiceTemp(): Promise<void> {
    const request: GetServicesTempRequest = {
      params: {
        tempCode: this.$route.query.tempCode as string
      }
    };

    return this.$api
      .getServiceTemp(request)
      .then((response: any) => {
        if (response && response.status === 200) {
          if (response.data.serviceStatus === REGISTER_STATUS.ACTIVE) {
            alert(this.toI18n('ALERT_EXIST_SERVICE'));
            // (임시-추후 복원)레거시 로그인 페이지로 이동을 위해
            this.$router.replace('/login');
            // window.location.href = '/login';
          } else if (response.data.serviceStatus === REGISTER_STATUS.INVESTIGATION) {
            alert(this.toI18n('ALERT_INVESTIGATION_SERVICE'));
            // (임시-추후 복원)레거시 로그인 페이지로 이동을 위해
            this.$router.replace('/login');
            // window.location.href = '/login';
          } else {
            this.serviceData = response.data;
            this.status = REGISTER_STATUS.REGISTER;
          }
        } else {
          this.status = REGISTER_STATUS.ERROR;
        }
      })
      .catch(() => {
        this.status = REGISTER_STATUS.ERROR;
      });
  }

  private getAdminsTempService(): Promise<void> {
    const request: GetAdminsTempServiceRequest = {
      params: {
        tempCode: this.$route.query.tempCode as string
      }
    };

    return this.$api
      .getAdminsTempService(request)
      .then((response: any) => {
        if (response && response.status === 200) {
          if (response.data.adminStatus === 'ACTIVE') {
            alert(this.toI18n('ALERT_EXIST_MASTER'));
            // (임시-추후 복원)레거시 로그인 페이지로 이동을 위해
            this.$router.replace('/login');
            // window.location.href = '/login';
          } else if (response.data.adminStatus === 'INVESTIGATION' && !this.$route.path.includes('registerCompletePage')) {
            alert(this.toI18n('ALERT_INVESTIGATION_MASTER'));
            // (임시-추후 복원)레거시 로그인 페이지로 이동을 위해
            this.$router.replace('/login');
            // window.location.href = '/login';
          } else if (response.data.adminStatus === 'DELETE') {
            alert(this.toI18n('ALERT_DELETE_MASTER'));
            // (임시-추후 복원)레거시 로그인 페이지로 이동을 위해
            this.$router.replace('/login');
            // window.location.href = '/login';
          } else {
            this.status = REGISTER_STATUS.REGISTER;
            this.masterData = response.data;
          }
        } else {
          this.status = REGISTER_STATUS.ERROR;
        }
      })
      .catch(() => {
        this.status = REGISTER_STATUS.ERROR;
      });
  }

  private toI18n(needToI18nStr: string, bCommon: boolean = false): string {
    return toI18n(this.$t((bCommon ? '' : 'SERVICE_REGISTER_') + needToI18nStr));
  }
}
